// Vendors
import React from 'react';
import { Facet } from '..';

const facets = ['market', 'format', 'purpose', 'file-type'];

const FacetList = () =>
  facets.map((facet) => {
    const title = `${facet.charAt(0).toUpperCase()}${facet.slice(1)}`;
    const attribute = `pa_${facet}`;

    return <Facet key={facet} id={facet} title={title} attribute={attribute} />;
  });

export default FacetList;
